import { render } from "./index.vue?vue&type=template&id=8e4f140a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8e4f140a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e4f140a"

export default script